import z from 'zod';

export const existingGuestData = z
    .object({
        name: z.string(),
        company: z.string().nullable(),
    })
    .nullable();

export type ExistingGuestData = z.infer<typeof existingGuestData>;

export const guestBookingData = z
    .object({
        guestBookingFullName: z.string().nullable(),
        guestBookingCompany: z.string().nullable(),
        guestBookingInitials: z.string().nullable(),
        guestBookingAnonymised: z.boolean(),
        guestBookingEmail: z.string().nullable().optional(),
    })
    .nullable();

export type GuestBookingData = z.infer<typeof guestBookingData>;
